import { GET } from "config/api.config";
import { COMMON } from "../config/apiEndPoint";

export const fetchStatusMetadata = async () => {
  const response = await GET(COMMON.STATUS_METADATA);
  return response;
};
